import { Navigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import Layout from '../../components/public/Layout';

// BHP-1042: OIDC redirect target. react-oidc-context exchanges the ?code for
// tokens (state + PKCE verified by the lib); this page only reflects the outcome.
const Callback = (): JSX.Element => {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <Layout
        title="Signing in…"
        forgotPassword={false}
        register={false}
        login={false}
        forgotPasswordLogin={false}
        loading={true}
      >
        <></>
      </Layout>
    );
  }

  // Invalid/missing code or a failed exchange: a clean message, no technical
  // details, and the user is not put in a logged-in state.
  if (auth.error !== undefined) {
    return (
      <Layout
        title="Sign-in failed"
        forgotPassword={false}
        register={false}
        login={false}
        forgotPasswordLogin={false}
        loading={false}
      >
        <>
          <p>We couldn&apos;t sign you in. Please try again.</p>
          <a href="/login" className="btn btn-primary btn-lg btn-block">
            Back to login
          </a>
        </>
      </Layout>
    );
  }

  if (auth.isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Navigate to="/login" replace />;
};

export default Callback;
